import { KYMW1308Model } from '../kymw1308.model';
import { KYMW1308GetPlanGoodsInfoModel } from '../vo/kymw1308-get-plan-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　企画商品情報を取得するサービス
 *
 * @export GetPlanGoodsInfoService
 * @class GetPlanGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanGoodsInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1308Model}
   * @memberof GetPlanGoodsInfoService
   */
  private model: KYMW1308Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1308GetPlanGoodsInfoModel}
   * @memberof GetPlanGoodsInfoService
   */
  private vo: KYMW1308GetPlanGoodsInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetPlanGoodsInfo: {
          condition: {
            OrderCode: this.vo.orderCode
          },
          combination: this.vo.pCodeList.map(pCode => {
            return {
              condition: {
                PCode: pCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPlanGoodsInfoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1308Model>model;
    this.vo = vo;
    this.send('getPlanGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanGoodsInfoService
   */
  success(data: any): void {
    this.model.updatePlanGoodsInfo(data);
    this.model.KYMW1308Component.setEnabledBtn();
    this.model.KYMW1308Component.setEnabledDiv();
    this.model.KYMW1308Component.txt_ApprovedNum.nativeElement.focus();
  }
}
